require('./accountMoreOptionsButton.scss');
const PropTypes = require('prop-types');
const { OKIconTask } = require('commonsComponents/OKIconTask');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ utilities
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');
const AccessHelper = require('utilities/accessHelper');
const { accountTypeIs } = require('utilities/accountTypeHelper');
const { ACCOUNT_TYPES } = require('utilities/accountsSortingHelper');
// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const {
    ACCOUNT_DEBITS,
    ACCOUNTS_PORTABILITY_ENABLED,
    AMAZON_GIFT_CARD,
    CHEQUES,
    HIRE_ACCOUNTS_ADD_DOCUMENTATION,
    OPEN_MARKETS_PERSONAL_DATA_CESSION,
    PAYROLL_ACCOUNT,
} = require('constants/flagBasedFeatures');
// @ actions
const accountAddDocumentationActions = require('actions/accountAddDocumentation');
const intervenersActions = require('actions/getAccountInterveners');

class AccountMoreOptionsButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fetchIntervenersSuccess: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            accountId,
            getTramitationExpedient,
            immAccountAddDocumentation,
            immAccounts,
        } = nextProps;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        let stateUpdates = null;

        if (!prevState.fetchIntervenersSuccess && (immAccountAddDocumentation.get('hasOneHolder') || (!!immAccount && !!immAccount.get('interveners') && prevState.fetchIntervenersSuccess !== immAccount.getIn(['interveners', 'fetchSuccess'])))) {
            getTramitationExpedient(immAccount.getIn(['ibanComplex', 'codbban']));

            stateUpdates = {
                fetchIntervenersSuccess: true,
            };
        }
        return stateUpdates;
    }

    componentDidMount() {
        const {
            accountId,
            immAccounts,
            requestAccountInterveners,
            setAccountInfo,
        } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);

        if (!!immAccount) {
            let accountInfo = {
                accountId,
                accountNumber: immAccount.get('iban'),
                alias: immAccount.get('alias'),
                expedientNumber: immAccount.getIn(['ibanComplex', 'codbban']),
                hasOneHolder: immAccount.getIn(['interveners', 'list']).size === 1,
                subtype: immAccount.getIn(['catalogData', 'subtype']),
            };

            if (!accountInfo.hasOneHolder && !immAccount.getIn(['interveners', 'fetchSuccess'])) {
                requestAccountInterveners(accountId).then(() => {
                    accountInfo.hasOneHolder = immAccount.getIn(['interveners', 'list']).size === 1;
                    setAccountInfo(accountInfo);
                });
            } else {
                setAccountInfo(accountInfo);
            }
        }
    }

    buildMoreOptions() {
        const {
            accountId,
            history,
            immAccountAddDocumentation,
            immAccounts,
            immFlagBasedFeatures,
        } = this.props;
        const openMarketsSectionFlag = immFlagBasedFeatures.get(OPEN_MARKETS_PERSONAL_DATA_CESSION);
        const immAccount = immAccounts.get('byId').get(accountId);
        const isInactiveAccount = immAccount.get('isInactiveAccount');
        const portabilityEnableFlag = immFlagBasedFeatures.get(ACCOUNTS_PORTABILITY_ENABLED);

        let options = [
            {
                link: `/myprofile/accounts/${accountId}/movements`,
                text: formatText('accountMoreOptions-movements')
            },
            {
                link: `/myprofile/transfers/transfer/account/${accountId}`,
                text: formatText('accountMoreOptions-transfer'),
                disabled: isInactiveAccount,
                icon: isInactiveAccount && 'icon-candado'
            },
            {
                link: `/myprofile/accounts/${accountId}/details`,
                text: formatText('accountMoreOptions-infoAccountAndContract')
            },
            {
                link: `/myprofile/accounts/${accountId}/settlements`,
                text: formatText('accountMoreOptions-settlements')
            }
        ];

        if (AccessHelper.allowAccess(accountConstants.ACCOUNTS_CHEQUES, { immAccounts, accountId }, history, false) && immFlagBasedFeatures.get(ACCOUNT_DEBITS)) {
            options.push(
                {
                    link: `/myprofile/accounts/${accountId}/debits`,
                    text: formatText('accountMoreOptions-debits')
                }
            );
        }

        if (AccessHelper.allowAccess(accountConstants.ACCOUNTS_CHEQUES, { immAccounts, accountId }, history, false) && immFlagBasedFeatures.get(CHEQUES)) {
            options.push(
                {
                    link: `/myprofile/accounts/${accountId}/cheques`,
                    text: formatText('accountMoreOptions-newChequebook')
                }
            );
        }

        if (AccessHelper.allowAccess(accountConstants.ACCOUNT_UPGRADEABLE_TO_PAYROLL, { immAccounts, accountId }, history, false) && immFlagBasedFeatures.get(PAYROLL_ACCOUNT)) {
            options.push({
                link: `/myprofile/purchase/upgrade-to-payroll-account?accountId=${accountId}`,
                text: formatText('accountMoreOptions-upgradeToPayrollAccount'),
                disabled: isInactiveAccount,
                icon: isInactiveAccount && 'icon-candado'
            });
        }

        if (AccessHelper.allowAccess(accountConstants.ACCOUNT_AMAZON_GIFT_CARD, { immAccounts, accountId }, history, false) && immFlagBasedFeatures.get(AMAZON_GIFT_CARD) && openMarketsSectionFlag) {
            options.push({
                link: `/myprofile/accounts/${accountId}/amazon-gift-check`,
                text: formatText('accountMoreOptions-amazonGiftCard')
            });
        }

        if (portabilityEnableFlag && AccessHelper.allowAccess(accountConstants.ACCOUNT_PORTABILITY, { immAccounts, accountId }, history, false)) {
            options.push({
                link: `/myprofile/accounts/${accountId}/bring-bank-account`,
                text: formatText('accountMoreOptions-accountMoreOptions_bringBankAccount')
            });
        }

        options.push({
            link: `/myprofile/accounts/${accountId}/certificates`,
            text: formatText('accountMoreOptions-certificates'),
            disabled: isInactiveAccount,
            icon: isInactiveAccount && 'icon-candado'
        });

        if (
            immFlagBasedFeatures.get(HIRE_ACCOUNTS_ADD_DOCUMENTATION) &&
            AccessHelper.allowAccess(accountConstants.ACCOUNT_UPLOAD_DOCUMENTATION, { immAccounts, immAccountAddDocumentation, accountId }, history, false)
        ) {
            options.push({
                link: `/myprofile/accounts/${accountId}/upload-documentation`,
                text: formatText('accountMoreOptions-accountUploadDocumentation'),
            });
        }

        return removeCurrentSectionOption(options);
    }

    buildMoreOptionsCC() {
        const {
            accountId,
            immAccountAddDocumentation,
            immAccounts,
            immAccountWarningMessage,
            immFlagBasedFeatures,
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const is123Account = accountTypeIs(ACCOUNT_TYPES.cuentaCorriente.cuenta123Openbank);
        const isCanceledAccount = !!immAccount.getIn(['filters', 'canceled'], false);
        const isBlockedAccount = !!immAccount.getIn(['filters', 'block'], false);
        const isInactiveAccount = !!immAccount.get('isInactiveAccount', false);
        const hasWarning = immAccountWarningMessage.getIn(['data', 'accountHasWarning']);
        const portabilityEnableFlag = immFlagBasedFeatures.get(ACCOUNTS_PORTABILITY_ENABLED);

        let options = [];

        if (!(__CONTACT_CENTER__ && isCanceledAccount)) {
            options.push(
                {
                    link: `/myprofile/accounts/${accountId}/movements`,
                    text: formatText('accountMoreOptions-movements')
                }
            );
        }

        !isCanceledAccount &&
        !isInactiveAccount
        && !isBlockedAccount
        && options.push({
            link: `/myprofile/transfers/transfer/account/${accountId}`,
            text: formatText('accountMoreOptions-transfer')
        });

        if (__CONTACT_CENTER__ && hasWarning) {
            options.push(
                {
                    link: `/myprofile/accounts/${accountId}/warnings`,
                    text: formatText('accountMoreOptions-warningsDetails')
                }
            );
        }

        options.push(
            {
                link: `/myprofile/accounts/${accountId}/details`,
                text: formatText('accountMoreOptions-infoAccountAndContract')
            },
            {
                link: `/myprofile/accounts/${accountId}/settlements`,
                text: formatText('accountMoreOptions-settlements')
            }
        );

        if (AccessHelper.allowAccess(accountConstants.ACCOUNTS_CHEQUES, { immAccounts, accountId }, history, false)) {
            if (!(__CONTACT_CENTER__ && isCanceledAccount)) {
                immFlagBasedFeatures.get(ACCOUNT_DEBITS) && options.push(
                    {
                        link: `/myprofile/accounts/${accountId}/debits`,
                        text: formatText('accountMoreOptions-debits')
                    }
                )
            }
            immFlagBasedFeatures.get(CHEQUES) && options.push(
                {
                    link: `/myprofile/accounts/${accountId}/cheques`,
                    text: formatText('accountMoreOptions-newChequebook')
                }
            );
        }

        if (__CONTACT_CENTER__ && isCanceledAccount) {
            options.push(
                {
                    link: `/myprofile/accounts/${accountId}/movements`,
                    text: formatText('accountMoreOptions-movements')
                }
            );
        }

        if (AccessHelper.allowAccess(accountConstants.ACCOUNT_UPGRADEABLE_TO_PAYROLL, { immAccounts, accountId }, history, false)) {
            options.push({
                link: `/myprofile/purchase/upgrade-to-payroll-account?accountId=${accountId}`,
                text: formatText('accountMoreOptions-upgradeToPayrollAccount')
            });
        }

        if (__CONTACT_CENTER__ && is123Account(immAccount)) {
            options.push({
                link: `/myprofile/accounts/${accountId}/benefits-account-123`,
                text: formatText('accountMoreOptions-benefits')
            });
        }


        if (portabilityEnableFlag && AccessHelper.allowAccess(accountConstants.ACCOUNT_PORTABILITY, { immAccounts, accountId }, history, false)) {
            options.push({
                link: `/myprofile/accounts/${accountId}/bring-bank-account`,
                text: formatText('accountMoreOptions-accountMoreOptions_bringBankAccount')
            });
        }

        !isCanceledAccount && options.push({
            link: `/myprofile/accounts/${accountId}/certificates`,
            text: formatText('accountMoreOptions-certificates')
        });

        if (
            immFlagBasedFeatures.get(HIRE_ACCOUNTS_ADD_DOCUMENTATION) &&
            AccessHelper.allowAccess(accountConstants.ACCOUNT_UPLOAD_DOCUMENTATION, { immAccounts, immAccountAddDocumentation, accountId }, history, false)
        ) {
            options.push({
                link: `/myprofile/accounts/${accountId}/upload-documentation`,
                text: formatText('accountMoreOptions-accountUploadDocumentation'),
            });
        }

        return removeCurrentSectionOption(options);
    }

    render() {
        const { accountId, immAccounts } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        let content = (
            <div></div>
        );

        if (immAccount) {
            const moreOptions = !__CONTACT_CENTER__ ? this.buildMoreOptions() : this.buildMoreOptionsCC()
            const targetElement = (
                <div className="account-more-options-button">
                    <div className="hidden-xs">
                        <OKButton
                            modifier="ghost"
                            inverse={true}
                            rightIcon="icon-dropdown-abrir"
                            smallRightIcon={true}
                        >
                            <FormattedText value="accounts-moreOptions" />
                        </OKButton>
                    </div>
                    <div className="visible-xs">
                        <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
                    </div>
                </div>
            );
            content = (
                <PopoverMenu
                    target={targetElement}
                    items={moreOptions}
                    placement="bottomRight"
                />
            );
        }

        return content;
    }
}

AccountMoreOptionsButton.propTypes = {
    accountId: PropTypes.string.isRequired,
    currentPath: PropTypes.string.isRequired,
    getTramitationExpedient: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountAddDocumentation: PropTypes.object.isRequired,
    immAccountWarningMessage: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    setAccountInfo: PropTypes.func.isRequired,
};

module.exports = connect(state => ({
    currentPath: state.routing.locationBeforeTransitions.pathname,
    immAccountAddDocumentation: state.accountAddDocumentation,
    immAccounts: state.accounts,
    immAccountWarningMessage: state.accountWarningMessage,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immProfile: state.profile,
}), {
    getTramitationExpedient: accountAddDocumentationActions.getTramitationExpedient,
    requestAccountInterveners: intervenersActions.requestAccountInterveners,
    setAccountInfo: accountAddDocumentationActions.setAccountInfo,
})(withRouter(AccountMoreOptionsButton));
